import { Faq } from "@appComponents/Faq";
import { Tabs } from "antd";
import React from "react";
import { faq, overviewFaq } from "../const";

const tabs = [
  {
    label: "Overview",
    key: "overview",
    children: (
      <>
        <Faq faq={overviewFaq} />
      </>
    ),
  },
  {
    label: "FAQ",
    key: "faq",
    children: <Faq faq={faq} />,
  },
];

export const FaqSection = () => {
  return (
    <div
      id="faq-section"
      className="border border-grey-lighter rounded-[12px] px-8 py-4 md:mt-[50px] mt-[20px]"
    >
      <Tabs
        defaultActiveKey={tabs[0].key}
        items={tabs}
        destroyInactiveTabPane
      />
    </div>
  );
};
